var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5"},[_c('new-driver'),_vm._l((_vm.driverList),function(item){return _c('driver',{key:item.id,attrs:{"item":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }